/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDragHandleAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M7 7H5V5h2zm0 6H5v-2h2zm-2 6h2v-2H5zm8-12h-2V5h2zm-2 6h2v-2h-2zm2 6h-2v-2h2zm4-12h2V5h-2zm2 6h-2v-2h2zm-2 6h2v-2h-2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgDragHandleAlt as DragHandleAlt };
